<template>
  <div class="sa-list-component" style="padding: 13px">
    <div class="sa-list-component-header">
      <b-row class="mb-4 align-items-center">
        <b-col cols="2" class="text-center">
          <span class="text-muted uppercase font-weight-bold">Storico Contabile</span>
          <h2 class="h4 font-weight-bold mb-0">{{ magazzinoArticolo.nomeArticolo }}</h2>
        </b-col>
        <b-col cols="8" class="text-center">
          <DateFilterComponent @submit="onSubmitFilter" :choiseNotVisible="['P', 'M']" btnDefault />
        </b-col>
        <b-col cols="2" class="text-right">
          <div style="border-left:3px solid #28a745"
            class="d-inline-block px-4 border-right text-center sa-badge sa-badge-legend">
            <span class="sa-articolo-label-mini text-success">Totale Avere</span>
            <span class="h4 font-weight-bold text-success">€ {{ totaleAvere }}</span>
          </div>
          <div style="border-left:3px solid #dc3545" class="d-inline-block px-4 text-center sa-badge sa-badge-legend">
            <span class="sa-articolo-label-mini text-danger">Totale Dare</span>
            <span class="h4 font-weight-bold text-danger">€ {{ totaleDare }}</span>
          </div>
        </b-col>
      </b-row>
    </div>
    <hr style="width: 80%;">
    <div class="sa-list-component-body">
      <b-container max-width="800px" style="height: 100%; overflow: auto">
        <div class="sa-articolo-timeline">
          <div v-for="(mov, index) in magazzinoArticoliMovimentazioneContabileItems" :key="index"
            class="sa-articolo-timeline-item">
            <div :class="getClass(mov, 'icon')">
              <i :class="getClass(mov, 'icon-icon')"></i>
            </div>

            <b-card class="sa-articolo-timeline-card" :class="getClass(mov, 'cardtimeline')">
              <span class="sa-utility-value"> <i class="far fa-clock mr-1"></i> {{
                formatDate(mov.documentoData) }} </span>

              <b-row align-v="center">
                <b-col cols="4">
                  <h5 class="mb-1 font-weight-bold" :class="getClass(mov, 'text')">
                    {{ mov.causaleDocumento }}
                  </h5>
                  <p class="mb-0 text-muted small">
                    <span class="sa-utility-label"><i class="fas fa-file-invoice mr-1"></i>Rif:
                    </span>
                    <span class="sa-utility-value">
                      {{ mov.tipoDocumento }} n. <b>{{ mov.documentoNumero }}</b>
                    </span>
                    <br />
                    <span class="sa-utility-label"><i class="fas fa-building mr-1"></i>Soggetto:
                    </span>
                    <span class="sa-utility-value">
                      {{ mov.ragioneSociale }}
                    </span>
                  </p>
                </b-col>
                <b-col cols="4" class="border-left text-center border-right">
                  <span class="sa-articolo-label-mini">Logistica</span>
                  <span class="d-block text-dark">Q.tà: <strong>{{ mov.quantitaRiga }} {{ mov.umRiga
                      }}</strong></span>
                  <span class="d-block text-muted text-xs">Prezzo Unit: € {{ mov.prezzoUnitario.toFixed(2) }}</span>
                </b-col>



                <b-col cols="4" class="text-right">
                  <span class="sa-articolo-label-mini">Importo Totale</span>
                  <div class="sa-articolo-price-tag mb-2">€ {{ mov.totaleImponibileRiga }}</div>

                  <b-badge :variant="getBadgeVariant(mov)" pill class="px-3 py-2 clickable-badge"
                    @click="mov.showPayments = !mov.showPayments">
                    {{ mov.stato }}
                    <!-- <i v-if="mov.transazioni.length" class="fas ml-2"
                      :class="mov.showPayments ? 'fa-chevron-up' : 'fa-chevron-down'"></i> -->
                  </b-badge>

                </b-col>
              </b-row>
            </b-card>
          </div>
        </div>
        <!-- <div class="text-center mt-4">
					<b-button variant="link" class="text-muted small">Mostra movimenti precedenti...</b-button>
				</div> -->
      </b-container>
    </div>
    <div class="sa-list-component-footer" style="padding-bottom: 15px"></div>
  </div>
</template>

<script>
// import axios from "axios";
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoMixins from "../mixins/MagazzinoMixins";
import DateFilterComponent from "../../utility/components/DateFilterComponent.vue";
// import ModalError from "../../../template/components/modal/components/ModalError.vue";
// import moment from "moment";
export default {
  name: "MagazzinoArticoliStoricoMovimentazioneGiacenza",
  mixins: [UtilityMixin, MagazzinoMixins],
  components: { DateFilterComponent },
  props: {
    visibleColumns: {
      type: Array,
      required: false,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      filtro: {},
      idArticolo: null,
      pathResource: "/contabilitadocumenti",
      pathResourceStampa: "/print/createreport",
      reportName: "documenti",
      stampaReport: null,
      rows: 0,
      fieldStorico: [
        {
          label: "Documento",
          key: "documento",
          sortable: true,
        },
        {
          label: "Codice Articolo",
          key: "articolo",
          sortable: true,
        },
        {
          label: "Prezzo Un.",
          key: "prezzoUnitario",
          sortable: true,
          formatter: (value) => value.toLocaleString("it-IT", { style: "currency", currency: "EUR" }),
        },
        {
          label: "Tip. Movimento",
          key: "causaleDocumentoOperazioneMagazzino",
          sortable: true,
        },
        {
          class: "sa-table-column-action-double",
          label: "",
          key: "actions",
        },
      ],
      jsonData: {},
      filter: {},
      storicoItems: [],
    };
  },
  computed: {
    fieldsColumn() {
      let me = this;
      let columns = [];
      if (!this.visibleColumns) {
        columns = this.fieldStorico;
      } else {
        columns = me.fieldStorico.filter((value) => this.visibleColumns.includes(value.key));
      }
      return columns;
    },
    totaleAvere() {
      if (this.magazzinoArticoliMovimentazioneContabileItems) {
        if (this.magazzinoArticoliMovimentazioneContabileItems.length > 0) {
          let mov = this.magazzinoArticoliMovimentazioneContabileItems[0];
          return mov.totaleGeneraleAvere
        }
      }
      return 0;
    },
    totaleDare() {
      if (this.magazzinoArticoliMovimentazioneContabileItems) {
        if (this.magazzinoArticoliMovimentazioneContabileItems.length > 0) {
          let mov = this.magazzinoArticoliMovimentazioneContabileItems[0];
          return mov.totaleGeneraleDare
        }
      }
      return 0;
    },

  },
  mounted() { },
  methods: {
    init(filtro, articolo) {
      if (filtro) {
        this.filtro = filtro;
      }
      if (articolo == null) {
        if (this.$route.params.id != null) {
          this.idArticolo = this.$route.params.id;
        }
      }
      this.loadDataArticolo();
      this.loadData();
    },
    getBadgeVariant(item) {
      let isSaldoPrecedente = item.tipoDocumento == 'Saldo Precedente';
      let isDare = item.dare > 0;
      let isAvere = item.avere > 0;
      if (isSaldoPrecedente) {
        return "info"
      }
      if (isSaldoPrecedente) {
        return "fas fa-file"
      }
      if (isDare) {
        return "danger";
      }
      if (isAvere) {
        return "success";
      }
    },
    loadDataArticolo() {
      this.magazzinoArticoloDettaglio(this.idArticolo);
    },

    loadData() {
      this.magazzinoArticoliMovimentazioneContabile(this.filtro);
    },
    getStyleOperazioneMagazzino(value) {
      return { color: value > 0 ? "green" : "red" };
    },
    onSubmitFilter(filter) {
      this.filtro.dataAl = filter.dataAl;
      this.filtro.dataDal = filter.dataDal;
      this.loadData();

    },
    onReset() { },
    isCarico(mov) {
      return mov.movUnitaBase > 0;
    },
    getClass(mov, sezione) {
      let operazione = null;
      if (mov.dare > 0) {
        operazione = 'dare';

      } else if (mov.avere > 0) {
        operazione = 'avere';
      }

      var variabile = null;
      switch (sezione) {
        case "icon-icon":
          variabile = "fas fa-hand-holding-usd";
          // 'fas fa-arrow-up' : 'fas fa-arrow-down'
          if (!operazione) {
            variabile = "fas fa-file"
          }
          return variabile;
        case "icon":
          //  'sa-articolo-icon-carico' : 'sa-articolo-icon-scarico'
          variabile = "sa-articolo-icon-scarico";
          if (operazione == null) {
            variabile = "sa-articolo-icon-censimento";
          } else if (operazione == 'avere') {
            variabile = "sa-articolo-icon-carico";
          }

          return "sa-articolo-timeline-icon " + variabile;
        case "cardtimeline":
          variabile = "sa-articolo-timeline-card-red";
          //  'sa-articolo-timeline-card-green' : 'sa-articolo-timeline-card-red'
          console.log("cardtimeline", operazione);
          if (operazione == null) {
            variabile = "sa-articolo-timeline-card-censimento";
          } else if (operazione == 'avere') {
            variabile = "sa-articolo-timeline-card-green";
          }

          return variabile;
        case "text":
          variabile = "text-danger";
          //  'sa-articolo-timeline-card-green' : 'sa-articolo-timeline-card-red'
          if (operazione == null) {
            variabile = "text-censimento";
          } else if (operazione == 'avere') {
            variabile = "text-success";
          }

          return variabile;
        case "badge":
          variabile = "sa-ft-color-scarico";
          //  'sa-articolo-timeline-card-green' : 'sa-articolo-timeline-card-red'
          if (operazione == null) {
            variabile = "sa-ft-color-censimento";
          } else if (operazione == 'avere') {
            variabile = "sa-ft-color-carico";
          }

          return variabile;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.sa-utility-label {
  display: inline;
}

.sa-utility-value {
  display: inline;
}

.sa-articolo-wrapper {
  background-color: #f0f2f5;
  min-height: 100vh;
  padding: 2rem 0;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

/* Struttura Core Timeline */
.sa-articolo-timeline {
  position: relative;
  padding: 20px 0;
  list-style: none;
}

/* La linea verticale */
.sa-articolo-timeline:before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 40px;
  width: 2px;
  background: #dee2e6;
}

/* Singolo elemento della timeline */
.sa-articolo-timeline-item {
  position: relative;
  margin-bottom: 30px;
  padding-left: 80px;
}

.sa-articolo-label-mini {
  font-size: 0.65rem;
  text-transform: uppercase;
  font-weight: 800;
  color: #94a3b8;
  display: block;
  letter-spacing: 0.5px;
}

/* Il cerchio sulla linea */
.sa-articolo-timeline-icon {
  position: absolute;
  left: 25px;
  top: 5px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid #007bff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  font-size: 0.8rem;
}

.sa-ft-badge-success {
  border: 1px solid #28a745 !important;
  background-color: #28a74628;
  padding: 15px;
  margin: 10px 10px;

  border-radius: 10px;
}

.sa-ft-badge-danger {
  border: 1px solid #dc3545 !important;
  background-color: #dc35462a;
  padding: 15px;
  margin: 10px 10px;
  border-radius: 10px;
}

.sa-articolo-timeline-card-green {
  border-left: 3px solid #28a745 !important;
}

.sa-articolo-timeline-card-green:hover {
  border-top: 1px solid #28a745 !important;
  border-right: 1px solid #28a745 !important;
  border-bottom: 1px solid #28a745 !important;
}

.sa-articolo-timeline-card-red {
  border-left: 3px solid #dc3545 !important;
}

.sa-articolo-timeline-card-red:hover {
  border-top: 1px solid #dc3545 !important;
  border-right: 1px solid #dc3545 !important;
  border-bottom: 1px solid #dc3545 !important;
}

.sa-articolo-timeline-card-censimento {
  border-left: 3px solid #007bff !important;
}

.sa-articolo-timeline-card-censimento:hover {
  border-top: 1px solid #007bff !important;
  border-right: 1px solid #007bff !important;
  border-bottom: 1px solid #007bff !important;
}

.sa-articolo-icon-carico {
  border-color: #28a745;
  color: #28a745;
}

.sa-ft-color-carico {
  background-color: #28a745 !important;
}

.sa-ft-color-scarico {
  background-color: #dc3545 !important;
}

.sa-ft-color-censimento {
  background-color: #007bff !important;
}

.sa-articolo-icon-scarico {
  border-color: #dc3545;
  color: #dc3545;
}

.sa-articolo-icon-censimento {
  border-color: #007bff;
  color: #007bff;
}

.text-censimento {
  color: #007bff;
}

/* Card del movimento */
.sa-articolo-timeline-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
}

.sa-articolo-timeline-card:hover {
  transform: translateX(5px);
}

.sa-articolo-date-label {
  font-size: 0.8rem;
  font-weight: bold;
  color: #6c757d;
  margin-bottom: 5px;
  display: block;
}

.sa-articolo-qty-badge {
  font-size: 1rem;
  font-weight: 700;
  padding: 5px 12px;
}

.sa-articolo-label-mini {
  font-size: 0.65rem;
  text-transform: uppercase;
  font-weight: 800;
  color: #94a3b8;
  display: block;
  letter-spacing: 0.5px;
}

.sa-articolo-price-tag {
  font-size: 1.25rem;
  font-weight: 800;
  color: #1e293b;
}
</style>
